<div class="no-data-placeholder" [className]="'no-data-placeholder ' + format"
     i18n="No data to display|No data to display@@atweb_job_empty_search_result">
  <div class="img"><i class="mdi mdi-cloud-search"></i></div>
  <div *ngIf="!detailMessage">No data found</div>
  <div class="detail-message">{{detailMessage}}</div>
</div>
